<table>
  <tr>
    <th>Status</th>
    <td>{{ statusMsg }}</td>
  </tr>
  <tr>
    <th>Realm</th>
    <td>{{ kcInstance?.realm }}</td>
  </tr>
  <tr>
    <th>Username</th>
    <td>{{ kcUserProfile?.username }}</td>
  </tr>
  <tr>
    <th>Name</th>
    <td>{{ kcUserProfile?.firstName }} {{ kcUserProfile?.lastName }}</td>
  </tr>
  <tr>
    <th>E-mail</th>
    <td>{{ kcUserProfile?.email }}</td>
  </tr>
  <tr>
    <th>Authenticated</th>
    <td>{{ user?.authenticated }}</td>
  </tr>
  <tr>
    <th>Token</th>
    <td>
      exp: {{kcInstance?.tokenParsed?.exp}}
      iat: {{kcInstance?.tokenParsed?.iat}}
      diff: {{kcInstance?.tokenParsed?.exp - kcInstance?.tokenParsed?.iat}}
    </td>
  </tr>
  <tr>
    <th>Refresh Token</th>
    <td>
      exp: {{kcInstance?.refreshTokenParsed?.exp}}
      iat: {{kcInstance?.refreshTokenParsed?.iat}}
      diff: {{kcInstance?.refreshTokenParsed?.exp - kcInstance?.refreshTokenParsed?.iat}}
    </td>
  </tr>
  <tr>
    <th>In aw-client-role</th>
    <td>
      angular service: {{this.inAwClientRole}}
      instance: {{this.inAwClientRoleFromInstance}}
    </td>
  </tr>
  <tr>
    <th>SSO Idle</th>
    <td>
      <countdown #ssoIdleCountdown [config]="ssoIdleCountdownConfig" class="countdown-hour"></countdown>
    </td>
  </tr>
  <tr>
    <th>SSO Max</th>
    <td>
      <countdown #ssoMaxCountdown [config]="ssoMaxCountdownConfig" class="countdown-hour"></countdown>
    </td>
  </tr>
  <tr>
    <th>Access Token Expiration</th>
    <td>
      <countdown #accessTokenCountdown [config]="accessTokenCountdownConfig" class="countdown-hour"></countdown>
    </td>
  </tr>
</table>

<div>
  <button pButton icon="fa fa-check" label="Refresh Token" (click)="keycloakSupport.updateToken()"></button>
  <button pButton icon="fa fa-check" label="Auto Login" (click)="onClickAutoLogin()"></button>
  <button pButton icon="fa fa-check" label="Auto Login wo Init" (click)="onClickAutoLogin(true)"></button>
  <button pButton icon="fa fa-check" label="Logout" (click)="onClickLogout()"></button>
</div>

<div>
  <button pButton icon="fa fa-check" label="Initial Login or Reload" (click)="onClickInitialLoginOrReload()"></button>
  <button pButton icon="fa fa-check" label="Reload Options and Init" (click)="onClickReloadOptionsAndInit()"></button>
</div>

<div>
  <button pButton icon="fa fa-check" label="Reset Options and Init" (click)="onClickResetOptionsAndInit()"></button>
  <button pButton icon="fa fa-check" label="Reset Options and Auto Login" (click)="onClickResetAndAutoLogin()"></button>
</div>

<div>
  <button pButton icon="fa fa-check" label="Load Profile via Angular Service" (click)="onClickLoadProfile()"></button>
  <button pButton icon="fa fa-check" label="Load Profile via Instance" (click)="onClickLoadInstanceProfile()"></button>
  <button pButton icon="fa fa-check" label="Check Role" (click)="onClickInRole()"></button>
</div>

<div>
  <button pButton icon="fa fa-check" label="Load Profile via Angular Service" (click)="onClickLoadProfile()"></button>
  <button pButton icon="fa fa-check" label="Load Profile via Instance" (click)="onClickLoadInstanceProfile()"></button>
  <button pButton icon="fa fa-check" label="Check Role" (click)="onClickInRole()"></button>
</div>

<div>
  <input pInputText type="text" [(ngModel)]="testRealm"/>
  <button pButton icon="fa fa-check" label="Validate Realm" (click)="onClickValidateRealm(testRealm)"></button>
</div>
